import Vue from "vue";
import VueRouter from "vue-router";

// Import your components
import loginView from '../views/LoginView.vue';

import homeView from "../views/homeView.vue";

import attendanceView from "../views/attendanceView.vue";

import accountView from "@/views/accountView.vue";
import accountGeneralView from "@/views/account/accountGeneralView.vue";
import accountSecurityView from "@/views/account/accountSecurityView.vue";
import flightOperationsView from "@/views/flightOperations/flightOperationsView.vue";
import adminView from "@/views/admin/adminView.vue";
import newUser from "@/views/admin/newUser.vue";
import newNews from "@/views/admin/newNews.vue";
import newAttendance from "@/views/admin/newAttendance.vue";
import newServiceBookEntryView from "@/views/flightOperations/serviceBook/newServiceBookEntryView.vue";
import serviceBookArchiveView from "@/views/flightOperations/serviceBook/serviceBookArchiveView.vue";
import guestflightView from "@/views/flightOperations/guestflightView.vue";
import newGuestflight from "@/views/admin/newGuestflight.vue";
import serviceBookOverallView from "@/views/flightOperations/serviceBook/serviceBookOverallView.vue";

Vue.use(VueRouter);

// Define routes
const routes = [
  { path: '/login', name: "LoginView", component: loginView },

  { path: "/", name: "HomeView", component: homeView, meta: { requiresAuth: true } },

  { path: "/attendance", name: "AttendanceView", component: attendanceView, meta: { requiresAuth: true } },

  { path: "/flight-operations", name: "FlightOperationsView", component: flightOperationsView, meta: { requiresAuth: true } },
  { path: "/flight-operations/service-book/overall", name: "serviceBookOverallView", component: serviceBookOverallView, meta: {requiresAuth: true} },
  { path: "/flight-operations/service-book/new-entry", name: "newServiceBookEntryView", component: newServiceBookEntryView, meta: {requiresAuth: true} },
  { path: "/flight-operations/service-book/archive", name: "serviceBookArchiveView", component: serviceBookArchiveView, meta: {requiresAuth: true} },
  { path: "/flight-operations/guest-flight", name: "guestFlightView", component: guestflightView, meta: { requiresAuth: true } },

  { path: "/account", name: "AccountView", component: accountView, meta: { requiresAuth: true }},
  { path: "/account/general", name: "AccountGeneralView", component: accountGeneralView, meta: { requiresAuth: true }},
  { path: "/account/security", name: "AccountSecurityView", component: accountSecurityView, meta: { requiresAuth: true }},

  { path: "/account/admin", name: "AdminView", component: adminView, meta: { requiresAuth: true }},
  { path: "/account/admin/new-user", name: "newUserView", component: newUser, meta: { requiresAuth: true }},
  { path: "/account/admin/new-news", name: "newNewsView", component: newNews, meta: { requiresAuth: true }},
  { path: "/account/admin/new-attendance", name: "newAttendanceView", component: newAttendance, meta: { requiresAuth: true }},
  { path: "/account/admin/new-guestflight", name: "newGuestflightView", component: newGuestflight, meta: { requiresAuth: true } }
];


const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.matched.some(record => record.meta.requiresAuth) && !token) {
    next('/login');
  } else {
    next();
  }
});

export default router;
